<div *ngIf="summaryInfoSelected" [ngClass]="public() ? '' : 'tab-area'">
  @if (public()) {
    <div class="header margin-y-3"><h1>BAER Current Status</h1>&nbsp;&nbsp;<a [href]="'#'">View Fire Tracker Map
      <fa-icon [icon]="faArrowUpRightFromSquare" class="fa-regular fa-green" aria-label="close"></fa-icon>
    </a>
    </div>
  }
  <div class="search-bar">
    <mat-form-field appearance="outline" style="max-width: 120px;">
      <mat-label>Year</mat-label>
      <mat-select [(value)]="filters.fire_discovery_years" (selectionChange)="search()">
        @for (year of yearsArray; track year) {
          <mat-option [value]="year">{{ year }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" style="max-width: 120px;">
      <mat-label>Region</mat-label>
      <mat-select [(value)]="filters.region" (selectionChange)="regionChanged()">
        <mat-option [value]="null">All</mat-option>
        @for (region of regions; track region) {
          <mat-option [value]="region">{{ region }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Forest</mat-label>
      <input #forest matInput [formControl]="forest_name" [matAutocomplete]="auto" (input)="filter()"
             (focus)="clearForest()" aria-label="Forest Name">
      <mat-icon matSuffix>arrow_drop_down</mat-icon>
      <mat-autocomplete requireSelection #auto="matAutocomplete" (optionSelected)="forestSelected()">
        @for (name of filtered_forest_names | async; track name) {
          <mat-option [value]="name">{{ name | forest_filter }}</mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
    <button class="usa-button usa-button--secondary" (click)="clearSearch()">Clear Filters</button>
  </div>
  <hr>
  <app-status-rollup [user]="user()" [summaryInfoSelected]="summaryInfoSelected" [type]="type"
                     [initTab]="false" (changeIndexInit)="indexChange($event)" [public]="public()"
  ></app-status-rollup>
  <div class="header"><h3>BAER AUTHORIZATION STATUS</h3></div>
  <div class="status-list">
    <div class="status-long-item">
      <div class="status-header">TOTAL BAER WILDFIRES</div>
      <div class="item">{{ summaryInfoSelected.fire_count ?? 0 }}</div>
    </div>
    <div class="status-long-item">
      <div class="status-header">TOTAL NFS ACRES</div>
      <div class="item">{{ (summaryInfoSelected.nfs_acres ?? 0) | number:'1.0-2' }}</div>
    </div>
    <div class="status-long-item">
      <div class="status-header">TOTAL FIRE ACRES</div>
      <div class="item">{{ (summaryInfoSelected.fire_acres ?? 0) | number:'1.0-2' }}</div>
    </div>
    <div class="status-long-item">
      <div class="status-header">TOTAL REQUESTED FUNDS</div>
      <div class="item">{{ '$' + (summaryInfoSelected.total_req ?? 0 | number:'1.2-2') | empty_check }}</div>
    </div>
    <div class="status-long-item">
      <div class="status-header">TOTAL AUTHORIZED</div>
      <div class="item">{{ '$' + (summaryInfoSelected.total_auth ?? 0 | number:'1.2-2') | empty_check }}</div>
    </div>
    <!-- <div class="status-long-item">
        <div class="status-header">TOTAL EXPENDITURES</div>
        <div class="item">$2,000</div>
    </div>
    <div class="status-long-item">
        <div class="status-header">EXPENDITURES (%)</div>
        <div class="item">{{(((2000)/(summaryInfoSelected.total_auth ?? 0))*100 | number:'1.2-2')+'%'}}</div>
    </div> -->
  </div>
  <app-status-summary [user]="user()" [summaryInfoRegion]="summaryInfoRegion" [summaryInfoForest]="summaryInfoForest"
                      *ngIf="!this.forest_name.value" (changeFilterCall)="changeFilter($event)"></app-status-summary>
  <app-treatment-chart [summaryInfoRegion]="summaryInfoRegion" [summaryInfoForest]="summaryInfoForest"
                       [summaryInfoSelected]="summaryInfoSelected"></app-treatment-chart>
</div>

